<template>
  <div>
    <div v-if="!appAccess">
      <div class="splash-screen">
        <div class="splash-container">
          Placeholder 401
          <div class="splash-double-bounce1"></div>
          <div class="splash-double-bounce2"></div>
        </div>
      </div>
    </div>
    <div v-else :class="containerClass" @click="onWrapperClick">
      <AppTopBar
          @menu-toggle="onMenuToggle"
          v-if="showTopBar && $auth.isAuthenticated"
      />

      <transition name="layout-sidebar">
        <div
            :class="sidebarClass"
            @click="onSidebarClick"
            v-if="isSidebarVisible() && $auth.isAuthenticated"
        >
          <div class="layout-logo">
            <router-link to="/">
              <img alt="Logo" :src="logo"/>
            </router-link>
          </div>

          <AppMenu :model="menu" @menuitem-click="onMenuItemClick"/>
        </div>
      </transition>

      <div class="layout-main">
        <router-view/>
      </div>
    </div>
  </div>
</template>

<script>
import AppTopBar from "./layout/AppTopbar.vue";
import AppMenu from "./layout/AppMenu.vue";
//import {Permissions} from './permissions/permissions';

export default {
  data() {
    return {
      staticMenuInactive: true,
      mobileMenuActive: false
    };
  },
  watch: {
    $route() {
      this.menuActive = false;
      this.$toast.removeAllGroups();
    },
  },
  methods: {
    onWrapperClick() {
      if (!this.menuClick) {
        this.mobileMenuActive = false;
      }

      this.menuClick = false;
    },
    onMenuToggle() {
      this.menuClick = true;

      if (this.isDesktop()) {
        this.staticMenuInactive = !this.staticMenuInactive;
      } else {
        this.mobileMenuActive = !this.mobileMenuActive;
      }

      event.preventDefault();
    },
    onSidebarClick() {
      this.menuClick = true;
    },
    onMenuItemClick(event) {
      if (event.item && !event.item.items) {
        this.mobileMenuActive = false;
      }
      this.onMenuToggle();
    },
    addClass(element, className) {
      if (element.classList) element.classList.add(className);
      else element.className += " " + className;
    },
    removeClass(element, className) {
      if (element.classList) element.classList.remove(className);
      else
        element.className = element.className.replace(
            new RegExp(
                "(^|\\b)" + className.split(" ").join("|") + "(\\b|$)",
                "gi"
            ),
            " "
        );
    },
    isDesktop() {
      return window.innerWidth > 1024;
    },
    isSidebarVisible() {
      return true;
    },
  },
  computed: {
    appAccess() {
      return true;  //this.$auth.user.permissions.hasAny(Permissions.MainGUI());
    },
    menu() {
      return [
        {
          label: "Scan by Location",
          icon: "pi pi-fw pi-check-circle",
          to: "/",
          visible: true
        },
          {
          label: "Scan Details",
          icon: "pi pi-fw pi-check-circle",
          to: "/scandetails",
          visible: true
        },
          {
          label: "Image Search",
          icon: "pi pi-fw pi-check-circle",
          to: "/imagesearch",
          visible: true
        },
      ];
    },
    containerClass() {
      return [
        "layout-wrapper",
        "layout-static",
        "layout-mobile-sidebar-active",

      ];
    },
    sidebarClass() {
      return ["layout-sidebar"];
    },
    logo() {
      return "assets/layout/images/new_logo_optel.svg";
    },
    showTopBar() {
      return this.$route.query.iframe ? false : true;
    },
  },
  beforeUpdate() {
    if (this.mobileMenuActive)
      this.addClass(document.body, "body-overflow-hidden");
    else this.removeClass(document.body, "body-overflow-hidden");
  },
  components: {
    AppTopBar: AppTopBar,
    AppMenu: AppMenu,
  },
};
</script>

<style lang="scss">
@import "./App.scss";
</style>

<style scoped>
</style>
